function activeCardClick(){
  jQuery('.card:not(.js-card-active-click)')
  .addClass('js-card-active-click')
  .on('click',(function () {
    let target = jQuery(this).find('.card__href').attr('target');
    let href = jQuery(this).find('.card__href').attr('href');

    if (target) {
      window.open(href);
    } else {
      window.location.href = href;
    }
  }))
  .find('.card_post__link button').on('click touchstart',(function(e){
    e.stopPropagation();
    jQuery(this).parents('.js-card-active-click').trigger('click');
  }));
}

jQuery(window).load(function () {
  activeCardClick();
});
jQuery( document ).ajaxComplete(function () {
  activeCardClick();
});